<script>
  import { appSession, appConstants } from "../stores/app.js";
 
  // resolve aircraft
  export function GetAirportSearch(query) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      let url = $appConstants.apiURLBase + "airportssearch/" + query;
      xhr.open("GET", url);

      xhr.setRequestHeader(
        "Authorization",
        "Bearer " + $appSession.authorisationToken
      );
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.send(null);
      xhr.onload = () => {
        try {
          if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
          let response = JSON.parse(xhr.response);
          if (response.success != true) throw response.errormessage;
          resolve(response.data);
        } catch (e) {
          reject(e);
        }
      };
      xhr.onerror = () => {
        reject("NetworkError");
      };      
    });
  }

</script>
